// SelectPipelineModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { DataPullerService } from '../../Services/DataPullerService';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

const SelectPipelineModal = ({ show, onPipelineSelect }) => {
    const { instance, accounts, inProgress } = useMsal();
    const [pipelines, setPipelines] = useState([]);
    const [selectedPipelineId, setSelectedPipelineId] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchPipelines();
    }, []);

    const fetchPipelines = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);
            const data = await DataPullerService.getPipelines(response.accessToken);
            setPipelines(data);
        } catch (error) {
            console.error('Failed to fetch pipelines:', error);
        }
    };

    const handlePipelineSelect = () => {
        if (selectedPipelineId) {
            onPipelineSelect(selectedPipelineId);
        }
    };

    const handleCancel = () => {
        navigate('/data-extraction');
    };

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton={false} className='border-bottom-0 px-4'>
                <Modal.Title className='text-info' id="contained-modal-title-vcenter">
                    Create new Data Selector Task
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='px-5 py-3'>
                <Form>
                    <p>Select an extraction type</p>
                    <Form.Group controlId="pipelineSelect">
                        {/* <Form.Label>Select Pipeline</Form.Label> */}
                        <Form.Select 
                            value={selectedPipelineId}
                            onChange={(e) => setSelectedPipelineId(e.target.value)}
                        >
                            <option value="" disabled>Type</option>
                            {pipelines.map(pipeline => (
                                <option key={pipeline.pipelineId} value={pipeline.pipelineId}>
                                    {pipeline.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className='border-top-0'>
                <Button size='lg' variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button size='lg' variant="primary" onClick={handlePipelineSelect} disabled={!selectedPipelineId}>
                    Select
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SelectPipelineModal;
